import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

const getColumns = (data) => {
  data.forEach((element, index) => {
    if (
      element.name.indexOf("ID") !== -1 ||
      element.name.indexOf("Estado") !== -1 ||
      element.name.indexOf("RSFV") !== -1 ||
      element.name.indexOf("Sucursal") !== -1
    ) {
      delete data[index];
    } else {
      element.sortable = true;
      element.selector = (row) => row[element.name];
      element.style = {
        background: "transparent",
      };
    }
  });
  return data;
};
const TableComponent = ({ dataComponent, entity, handleOpenModal }) => {
  const [state, setState] = useState({
    filtro: "",
  });
  const conditionalRowStyles = [
    {
      when: (row) => {
        return row.toggleSelected;
      },
      style: {
        backgroundColor: "#E2EED8",
        userSelect: "none",
      },
    },
  ];
  useEffect(() => {
    const columns = getColumns(dataComponent.columns);
    switch (entity.toUpperCase()) {
      case 'CABECERA':
        setState({
          filtro: state.filtro,
          placeholder: 'Filtrar por guía',
          columns: columns,
        });
      case 'DETALLE':
        setState({
          filtro: state.filtro,
          placeholder: 'Filtrar por codigo, descripción o lote',
          columns: columns,
        });
    }
  }, []);
  const onFilter = (e) => {
    setState({
      filtro: e.target.value.toUpperCase(),
      placeholder: '',
      columns: state.columns,
    });
  };
  const onData = (data) => {
    switch (entity.toUpperCase()) {
      case 'CABECERA':
        return data.filter((item) => item.Guia && item.Guia.includes(state.filtro));
      case 'DETALLE':
        return data.filter((item) => item.Codigo.includes(state.filtro) || item.Descripcion.includes(state.filtro) || item.Lote.includes(state.filtro));
    }
    return data;
  };
  return (
    <>
      <div className="flex flex-col w-full">
        <div className="flex justify-end">
          <div className="mb-3 w-[19%]">
            <input
              type="text"
              className="
        form-control
        block
        w-full
        px-3
        py-1.5
        text-base
        font-normal
        text-gray-700
        bg-white bg-clip-padding
        border border-solid border-gray-300
        rounded
        transition
        ease-in-out
        m-0
        focus:text-gray-700 focus:bg-white focus:border-green-600 focus:outline-none
      "
              id="exampleText0"
              placeholder={state.placeholder}
              value={state.filtro}
              onChange={onFilter}
            />
          </div>
        </div>
        <div className="w-full">
          <DataTable
            columns={state.columns}
            data={onData(dataComponent.data)}
            onRowDoubleClicked={handleOpenModal}
            conditionalRowStyles={conditionalRowStyles}
            noDataComponent='No se encontraron resultados con los filtros ingresados.' 
            responsive
            persistTableHead
          />
        </div>
      </div>
    </>
  );
};
export default TableComponent;
